import {  Component,  OnInit, ChangeDetectorRef, DebugElement} from '@angular/core';
import {  BatchService, EquipmentService,  ModelService,  SqacodeService,  WorktypeService,  PayrollCodeService,  ManufacturerService,  PartsService,  SqasubcodeService} from 'src/app/services';
import {  SelectItem,  SortEvent} from 'primeng/api';
import { AccessUserInfo,  BatchDetails,  BatchSelectedData,  DiscreteMeasures,  AdminBatchMeasure,  AdminBatchPart } from 'src/app/models';
import {  DatePipe} from '@angular/common'
import { ConfirmationService } from 'primeng/api';

@Component({
  selector: 'bart-batch-manager',
  templateUrl: './batch-manager.component.html',
  styleUrls: ['./batch-manager.component.scss']
})
export class BatchManagerComponent implements OnInit { 
  public bmConfirmation:boolean=false;
  public showHideSaveBatchDetailsBtn: boolean=false;
  index: number = 0;  
  public meas: string = null;
  public dis = false;
  public batchManagerBatchId: number = 0;
  public tableBatchName: string = '';
  public errors = [];
  public isValid: any = 0;
  datePiepe = new DatePipe('en-US')
  userDetail: any = null;
  public static retBatchid: any;
  public static updateBatchid: any;
  public selectedValue: boolean;
  public measureYesNoList: SelectItem[];
  public SelectedRowData: BatchSelectedData;
  public SelectedBatchMeasureRowData: AdminBatchMeasure;
  public SelectedBatchPartRowData: AdminBatchPart;
  public isDisabled: boolean = false;
  public Header = "";
  public Content = "";
  public messagePopup: boolean = false;
  public ErroDialog: boolean = false;

  public loading: boolean = false;
  public cols: any[];
  public dmcols: any[];
  public partcols: any[];

  public batchDataSource: BatchDetails[] = [];
  public batchDetails: BatchDetails = null;
  public isPaginatorVisible: boolean = true;
  public batchObj: object;
  public ticketCount = 0
  public isActiveFlagSelected: boolean = true;
  public isEnableRemoveBatch: boolean = false;

  public SQADataSource: any[];
  public WorkTypesDataSource: any[];
  public EquipmentTypeDataSource: any[];
  public PayrollCodeDataSource: any[];
  public DiscreteMeasuresDataSource: SelectItem[];
  public DiscreteMeasuresList: DiscreteMeasures[] = [];
  public EquipmentManufacturerDataSource: any[];
  public ModelPartsDataSource: any[];
  public EquipmentSubtypeDataSource: any[];
  public EquipmentModelDataSource: SelectItem[];
  public SqaSubCodesDataSource: any[];
  public BatchMeasuresDataSource: AdminBatchMeasure[] = [];
  public BatchPartsDataSource: any[];
  public batchPartDataSource: AdminBatchPart[] = null
  public divBatchEntryShow: boolean = false;
  public divBatchInfoBoxShow: boolean = false;
  public sqaSubCodeItemShow: boolean = false;
  public divBatchListings: boolean = true;
  public isRadioDisable = false;

  public isEdite: boolean = false;
  public selectedManufacturarSubTypeId: any;
  public selectedEquipmentSubtypeId: any;
  public SelectedDiscreteMeasureAttribute: DiscreteMeasures;
  public batchUtilizesDeviceRadioValue: number = null;

  public ObjGetManufacturersForAddeEuip: Object;
  public ObjGetObjGetManufacturersForAddeEuip: Object
  public ObjGetDiscreteMeasures: Object;
  public ObjGetModelParts: Object;

  public showHideaddMeasureBtn: boolean = false;
  public showHidesaveMeasureBtn: boolean = true;
  public showHidecancelMeasureBtn: boolean = true;

  public showHideaddPartBtn: boolean = false;
  public showHidesavePartBtn: boolean = true;
  public showHidecancelPartBtn: boolean = true;

  public showManufacturerItem: boolean = false;
  public InformationShow: boolean = true;
  public showEquipment: boolean = false;
  public showManufacturer: boolean = false;
  public showDiscreteMeasures: boolean = false;  
  public showParts: boolean = false;
  public showSummary: boolean = false;
  public modelItem: boolean = false;

  public GETWORKTYPES = {
    "WorkTypeId": null,
    "isScheduledFlag": "1",
    "isUnscheduledFlag": null,
    "isCanBatchFlag": null
  };
  public GETSQASUBCODES = {
    "SQACodeID": 14, //Hard code for "PREVENTATIVE MAINTENANCE" SQA Code.
    "SQASubCodeID": null,
    "SQASubCode": null,
    "allCodes": null,
    "isFrequencyFlag": null,
    "isSQACode": 1,
    "isSQASubCode": 0
  }

  constructor(private batchService: BatchService, private equipmentService: EquipmentService, private modelService: ModelService, private sqacodeService: SqacodeService, private worktypeService: WorktypeService, private payrollCodeService: PayrollCodeService, private manufacturerService: ManufacturerService, private partsService: PartsService, private sqasubcodeService: SqasubcodeService, private changeDetectorRef: ChangeDetectorRef,
    private _confirmationService: ConfirmationService) {

    this.userDetail = AccessUserInfo.getUserInfo();

    this.SelectedRowData = {
      batchid: null,
      isActiveFlag: 1,
      BatchName: '',
      ticketCount: null,
      effectiveDate: '',
      expirationDate: '',
      batchdescription: '',
      sqacodeid: null,
      sqasubcodeid: null,
      worktypeid: null,
      payrollcodeid: null,
      equipmentsubtypeid: null,
      equipmenttypeid: null,
      manufacturerId: null,
      ModelId: null,
      servicerequested: '',
      findings: '',
      workperformed: null,
      countBatchPart: 0,
      countDiscreteMeasures: 0,
    }
    this.SelectedBatchMeasureRowData = {
      batchId: null,
      discreteMeasureId: null,
      discreteMeasureAttributeId: null,
      discreteMeasureTypeId: null,
      MinValue: null,
      MaxValue: null,
      minDate1: null,
      maxDate1: null,
      answer: null,
      discreteMeasureTypeDesc: null,
      discreteMeasureAttributeDesc: null,
    }

    this.SelectedBatchPartRowData = {
      batchPartId: null,
      batchId: null,
      SelectedPartId: null,
      PartQuantity: null,
      partDescription: null,
      partNumber: null,
      unitCost: null,
      manufacturerName: null
    }

    this.BatchMeasuresDataSource= [];
    this.BatchPartsDataSource=[];
    this.SQADataSource=[];
    this.SqaSubCodesDataSource=[];
  }

  ngOnInit() {

    this.ObjGetDiscreteMeasures = {
      "GETDISCRETEMEASURES": {
        "discreteMeasureAttributeId": 0
      }
    };

    this.batchObj = {
      "GETBATCHES": {
        "BatchId": "0",
        "isActiveFlag": "",
        "isAvailable": ""
      }
    };

    this.cols = [{
        field: 'batchid',
        header: 'Batch Id',
        display: 'none'
      },
      {
        field: 'isActiveFlag',
        header: 'Active',
        display: 'none'
      },

      {
        field: 'BatchName',
        header: 'Name',
        display: 'table-cell'
      },
      {
        field: 'ticketCount',
        header: 'Tickets',
        display: 'table-cell'
      },
      {
        field: 'effectiveDate',
        header: 'Effective Date',
        display: 'table-cell'
      },
      {
        field: 'expirationDate',
        header: 'Expiration Date',
        display: 'table-cell'
      },
    ];

    this.dmcols = [{
        field: 'discretemeasureattributedesc',
        header: 'Discrete Measure Attribute',
        display: 'table-cell'
      },
      {
        field: 'Values',
        header: 'Values',
        display: 'table-cell'
      },
      {
        field: 'discreteMeasureId',
        header: 'discreteMeasureId',
        display: 'none'
      },
      
    ];

    this.partcols = [

      {
        field: 'partDescription',
        header: 'partDescription',
        display: 'table-cell'
      },
      {
        field: 'quantity',
        header: 'quantity',
        display: 'table-cell'
      },
    ];

    this.getPayrollCodes();
    this.loadBatchData(this.batchObj);
    this.getSQACodes();
    this.loadWorkTypes(this.GETWORKTYPES);
    //this.getSqaSubCodes(this.GETSQASUBCODES);
    this.getEquipmentTypeData();
    this.getDiscreteMeasures(this.ObjGetDiscreteMeasures);
    this.loadYesNoFields();
  }

  public selectedItemRow:number;
  public highLightRow(itemId)
    {
      this.selectedItemRow=itemId
    }
    
  loadBatchData(batchtObj: object) {
    if (batchtObj) {      
      this.loading = true;
      this.batchDataSource = [];
      this.batchService.getBatches(JSON.stringify(batchtObj))
        .subscribe((batchResponse: any) => {          
          this.batchDataSource = [];
          if (batchResponse.batches.length > 0) {
            this.batchDataSource = batchResponse.batches;
            this.loading = false;
          } else {
            this.batchDataSource = null;
            this.loading = false;
          }
        }, (respose: Response) => {
          this.batchDataSource = [];
          this.loading = false;
          // handle error here
        });
    }
  }

  customSort(event: SortEvent) {
    event.data.sort((data1, data2) => {
      let value1 = data1[event.field];
      let value2 = data2[event.field];
      let result = null;

      if (value1 == null && value2 != null)
        result = -1;
      else if (value1 != null && value2 == null)
        result = 1;
      else if (value1 == null && value2 == null)
        result = 0;
      else if (typeof value1 === 'string' && typeof value2 === 'string')
        result = value1.localeCompare(value2);
      else
        result = (value1 < value2) ? -1 : (value1 > value2) ? 1 : 0;

      return (event.order * result);
    });
  }
  public onChangeWorkType() {
    this.isDisabled = false;
    
  }
  //Create Batch

  public onClickCreateNewBatchBtn() {  
    this.BatchMeasuresDataSource=[];
    this.batchPartDataSource=[];
    this.disManufacturer=false;
    this.disBatchUtilized= false; 
    this.index = 0;
    this.batchUtilizesDeviceRadioValue = null;
    this.divBatchInfoBoxShow = true;
    this.showParts = false;
    this.showManufacturerItem = false;

    this.isEdite = false;
    this.isRadioDisable = false;

    this.divBatchEntryShow = true;
    this.divBatchInfoBoxShow = true;
    this.divBatchListings = false;

    this.showHideaddMeasureBtn = false;
    this.showHidesaveMeasureBtn = true;
    this.showHidecancelMeasureBtn = true;

    this.SelectedRowData = {
      batchid: null,
      isActiveFlag: 1,
      BatchName: '',
      ticketCount: null,
      effectiveDate: '',
      expirationDate: '',
      batchdescription: '',
      sqacodeid: null,
      sqasubcodeid: null,
      worktypeid: null,
      payrollcodeid: null,
      equipmentsubtypeid: null,
      equipmenttypeid: null,
      manufacturerId: null,
      ModelId: null,
      servicerequested: '',
      findings: '',
      workperformed: null,
      countBatchPart :0,
      countDiscreteMeasures :0
    }

    this.SelectedBatchMeasureRowData = {
      batchId: null,
      discreteMeasureId: null,
      discreteMeasureAttributeId: null,
      discreteMeasureTypeId: null,
      MinValue: null,
      MaxValue: null,
      minDate1: null,
      maxDate1: null,
      answer: null,
      discreteMeasureTypeDesc: null,
      discreteMeasureAttributeDesc: null,
    }
  }

  //Show Batch Details on Batch Name Click
  public clickUpdateBatch(batchId) { 
   
    this.showSaveSummaryBtn=false;
    this.index = 0;    
    if(this.SelectedRowData.countBatchPart<0)
    {
      this.InformationShow = true;
      this.showParts = true; 
      this.showDiscreteMeasures = true;  
      this.showSummary = true;
      this.showEquipment = false;
      this.showManufacturer = false;    
    }
    else{
    this.InformationShow = true;
    this.showEquipment = true;
    this.showManufacturer = true;
    this.showDiscreteMeasures = true;
    this.showParts = true;
    this.showSummary = true;
    }  

    this.isRadioDisable = true;
    this.divBatchEntryShow = true;
    this.divBatchInfoBoxShow = true;
    this.divBatchListings = false;    
    this.isEdite = true;
    let RowData: any = this.batchDataSource.find(x => x.batchid == batchId);
    this.SelectedRowData = RowData;
    BatchManagerComponent.updateBatchid = batchId;
    this.tableBatchName = ": " + this.SelectedRowData["BatchName"];
    this.SelectedRowData.equipmenttypeid = this.SelectedRowData["EquipmentTypeId"];

    this.SelectedRowData.servicerequested=this.SelectedRowData["ServiceRequested"];
    this.SelectedRowData.findings=this.SelectedRowData["Findings"];
    this.SelectedRowData.workperformed=this.SelectedRowData["WorkPerformed"];
    this.SelectedRowData.sqasubcodeid=this.SelectedRowData["SQASubCodeId"];
    this.SelectedRowData.batchdescription=this.SelectedRowData["BatchDescription"];
    this.SelectedRowData.payrollcodeid=this.SelectedRowData["payrollCodeId"];
    this.SelectedRowData.worktypeid=this.SelectedRowData["WorkTypeId"];
    this.SelectedRowData.sqacodeid=this.SelectedRowData["SQACodeId"];    
    this.SelectedRowData.manufacturerId=this.SelectedRowData["ManufacturerId"]; 


    if (this.SelectedRowData.equipmenttypeid != null) {
      this.showManufacturer = true;
    } else {
      this.showManufacturer = false;
    }

    if (this.SelectedRowData.equipmenttypeid != undefined) {
      var GETEQUIPMENTSUBTYPES = {
        "equipmenttypeid": this.SelectedRowData.equipmenttypeid,
      }
      this.getEquipmentSubtypes(GETEQUIPMENTSUBTYPES);
    }

    this.SelectedRowData.equipmentsubtypeid = this.SelectedRowData["EquipmentSubTypeId"];
    if (this.SelectedRowData.equipmentsubtypeid != undefined) {
      this.ObjGetManufacturersForAddeEuip = {
        "GETMANUFACTURERSFORADDEQUIP": {
          "equipmentTypeId": null,
          "equipmentSubTypeId": this.SelectedRowData.equipmentsubtypeid,
        }
      };
      this.getManufacturersForAddEquip(this.ObjGetManufacturersForAddeEuip);
    }    
    this.SelectedRowData.manufacturerId = this.SelectedRowData["ManufacturerId"];

    if (this.SelectedRowData.manufacturerId != undefined) {
      this.ObjGetObjGetManufacturersForAddeEuip = {
        "GETMODELSFORADDEQUIP": {
          "manufacturerId": this.SelectedRowData.manufacturerId,
          "equipmentTypeId": 0,
          "equipmentSubTypeId": 0
        }
      };
      this.getModelsForAddEquip(this.ObjGetObjGetManufacturersForAddeEuip);
    }

    this.SelectedRowData.ModelId = this.SelectedRowData["ModelId"];
    if (this.SelectedRowData.ModelId != undefined) {

      this.ObjGetModelParts = {

        "GETMODELPARTS": {
          "modelId": this.SelectedRowData.ModelId,
          "searchTerm": '',
          "sortColumn": 'partDescription ASC'
        }
      };
      this.getModelParts(this.ObjGetModelParts);
    }    
    this.getSqaSubCodes(this.GETSQASUBCODES);
    this.getBatchMeasures(batchId);   
    this.getBatchParts(batchId);  
    // this.activateBatchUtilized();
    // this.activateManufacturer();
   
    if (this.SelectedRowData.manufacturerId>0 ) {      
      this.batchUtilizesDeviceRadioValue = 1;      
    } else {     
      this.batchUtilizesDeviceRadioValue = 0;
    }
  }
  //**********************************Save/Update Batch********************************************//

  tabResetforSaveBatch() {    
    if (this.isEdite) {
      this.InformationShow = true;
      this.showEquipment = true;
      this.showManufacturer = true; 
      this.showDiscreteMeasures = true;
      this.showParts = true;
      this.showSummary = true;
    } else {
      this.InformationShow = true;
      this.showEquipment = true;
      this.showManufacturer = false;
      this.showDiscreteMeasures = false;
      this.showParts = false;
      this.showSummary = false;
    }    
  }
  /**************************Add/Update Batch**********************************/

  onClicksaveBatchDetailsBtn() {
     
    this.errors = [];   

    if (this.SelectedRowData.batchid == null) {
      
      var ADDBATCH = {
        "BatchName": this.SelectedRowData.BatchName,
        "BatchDescription": this.SelectedRowData.batchdescription,
        "sqaCodeId": this.SelectedRowData.sqacodeid,
        "SQASubCodeId": this.SelectedRowData.sqasubcodeid,
        "WorkTypeId": this.SelectedRowData.worktypeid,
        "payrollCodeId": this.SelectedRowData.payrollcodeid,
        "EffectiveDate": this.SelectedRowData.effectiveDate,
        "ExpirationDate": this.SelectedRowData.expirationDate,
        "isActiveFlag": "1",
        "userId": this.userDetail.userId
      }
      this.errors = [];
      if (this.checkErrors() <= 0)
      {
        return false;
      }
      this.addBatch(ADDBATCH);
      this.Header = "Batch Message";
      this.Content = "Batch saved successfully.";
      this.messagePopup = true;
      this.tabResetforSaveBatch();  
      this.index = 1; 
    } else {
     
      var UPDATEBATCH = {
        "BatchId": this.SelectedRowData.batchid,
        "BatchName": this.SelectedRowData.BatchName,
        "BatchDescription": this.SelectedRowData.batchdescription,
        "WorkTypeId": this.SelectedRowData.worktypeid,
        "payrollCodeId": this.SelectedRowData.payrollcodeid,
        "EffectiveDate": this.SelectedRowData.effectiveDate,
        "ExpirationDate": this.SelectedRowData.expirationDate,
        "SQACodeId": this.SelectedRowData.sqacodeid,
        "SQASubCodeId": this.SelectedRowData.sqasubcodeid,
        "userId": this.userDetail.userId,
        "isActiveFlag": this.SelectedRowData.isActiveFlag
      }

      this.errors = [];
      if (this.checkErrors() <= 0)
      {
        return false;
      }
      this.updateBatch(UPDATEBATCH);
      this.Header = "Batch Message";
      this.Content = "Batch updated successfully.";
      this.messagePopup = true;
      this.tabResetforSaveBatch();
      this.index = 1;           
    }
    
  }
  //**********************************End Save/Update Batch********************************************//

  //Delete Batch Part
  public deleteBatchPart(DELETEBATCHPART: any) {
    this.loading=true;
    this.batchService.deleteBatchPart(JSON.stringify({
        DELETEBATCHPART
      }))
      .subscribe((deleteBatchPartResponse: any) => {
        this.getBatchParts(this.SelectedRowData.batchid);
        this.changeDetectorRef.detectChanges();
      }, (respose: Response) => {
        this.loading=false;
        // handle error here
      });
  }

  /**************************Remove Batch**********************************
    1. Delete Batch Part
    2. Delete Discrete Measure
    3. Delete Batch 
  ********************************************************************* */

  public removeBatch(batchid: number) {
    var DELETEBATCH = {
      "BatchId": batchid
    };

    var DELETEBATCHPART = {
      "BatchId": batchid,
      "batchPartId": null
    };

    var DELETEDISCRETEMEASURE = {
      BatchId: batchid,
      discreteMeasureId: null
    };
    this.bmConfirmation=true;
    this._confirmationService.confirm({
      message: 'Are you sure you want to remove the selected row?',
      accept: () => {              
        this.deleteBatchPart(DELETEBATCHPART);
        this.deleteDiscreteMeasure(DELETEDISCRETEMEASURE);
        this.deleteBatch(DELETEBATCH);

        this.loadBatchData(this.batchObj);
        this.getBatchMeasures(this.SelectedRowData.batchid);
        this.getBatchParts(this.SelectedRowData.batchid);
        
        this.Header = "Batch Message";
        this.Content = "Batch deleted";
        this.messagePopup = true;
        this.bmConfirmation=false;
      },
      reject: () => {              
        this.bmConfirmation=false;
      }

    });
    
  }
  //********************************End  Remove Batch*********************************//

  //Get SQA Codes
  getSQACodes() {
    var GETSQACODES = {
      "SQACode": null,
      "SQACodeID": null,
      "allCodes": "1"
    }
    this.SQADataSource=[];
    this.sqacodeService.getSQACodes(JSON.stringify({
      GETSQACODES
    })).subscribe((Result: any) => {
        if (Result.length > 0) {
          this.SQADataSource = Result.map(data => ({
            label: data.SQADescription,
            value: data.SQACodeId,
          }));
        }
      },
      (respose: Response) => {
        // handle error here
      }
    );
  }

  //Get Work Type
  loadWorkTypes(GETWORKTYPES: any) {
    this.WorkTypesDataSource = [];
    this.worktypeService.getWorkTypes(JSON.stringify({
        GETWORKTYPES
      }))
      .subscribe((allWorkTypesResponse: any) => {
        if (allWorkTypesResponse.length > 0)
         
        this.WorkTypesDataSource.push({
          label: "- Work Type -",
          value: -1
        });
        for (let c of allWorkTypesResponse) {
          this.WorkTypesDataSource.push({
            label: c.WorkTypeCode,
            value: c.WorkTypeId
          });
        }

      }, (respose: Response) => {
        this.WorkTypesDataSource = [];
        // handle error here
      });
  }

  //Get Equipment Type
  getEquipmentTypeData() {
    this.EquipmentTypeDataSource = [];
    this.equipmentService.getEquipmentTypes()
      .subscribe((getEquipmentResponse: any) => {
          this.EquipmentTypeDataSource = [];
          if (getEquipmentResponse.equipmentType.length > 0) {
            this.EquipmentTypeDataSource.push({
              label: "- Type -",
              value: -1
            });
            for (let c of getEquipmentResponse.equipmentType) {
              this.EquipmentTypeDataSource.push({
                label: c.EquipmentTypeDescription,
                value: c.EquipmentTypeId
              });
            }
          }
        },
        (respose: Response) => {
          this.EquipmentTypeDataSource = [];
          // handle error here
        }
      );
  }

  //Get Payroll Codes
  public getPayrollCodes() {
    this.PayrollCodeDataSource=[];
    this.payrollCodeService.getPayrollCodes(null)
      .subscribe((Result: any) => {
          if (Result.length > 0) {
            this.PayrollCodeDataSource = Result.map(data => ({
              label: data.payrollCodeDescription,
              value: data.payrollCodeId,
            }));
          }
        },
        (respose: Response) => {
          this.PayrollCodeDataSource = [];
          // handle error here
        }
      );
  }

  //Get Equipment Subtypes
  getEquipmentSubtypes(GETEQUIPMENTSUBTYPES: any) {
    this.loading = true;
    this.EquipmentSubtypeDataSource = [];
    this.equipmentService.getEquipmentSubtypes(JSON.stringify({
        GETEQUIPMENTSUBTYPES
      }))
      .subscribe((allManufacturarTypeResponse: any) => {
        if (allManufacturarTypeResponse.equipmentSubType.length > 0)
          this.EquipmentSubtypeDataSource = [];
        this.EquipmentSubtypeDataSource.push({
          label: "- Sub-Type -",
          value: -1
        });
        for (let c of allManufacturarTypeResponse.equipmentSubType) {
          this.EquipmentSubtypeDataSource.push({
            label: c.EquipmentSubTypeDescription,
            value: c.EquipmentSubTypeId
          });;
        }
        this.loading = false;
      }, (respose: Response) => {
        this.EquipmentSubtypeDataSource = [];
        this.loading = false;
      });
  }

  //Get Discrete Measures
  getDiscreteMeasures(batchObj: object) {
    this.DiscreteMeasuresDataSource = [];
    this.batchService.getDiscreteMeasures(JSON.stringify(batchObj))
      .subscribe((Response: any) => {
        this.DiscreteMeasuresDataSource = [];
        this.DiscreteMeasuresDataSource.push({
          label: "- Choose One -",
          value: -1
        });
        if (Response.measures.length > 0) {
          for (let c of Response.measures) {
            this.DiscreteMeasuresDataSource.push({
              label: c.discreteMeasureAttributeDesc,
              value: c.discreteMeasureAttributeId
            });
          }
        }
        this.activateManufacturer();
      });
  }

  //Get Equipment Manufacturer
  getManufacturersForAddEquip(GETMANUFACTURERSFORADDEQUIP: any) {
    this.EquipmentManufacturerDataSource = [];
    this.manufacturerService.getManufacturersForAddEquip(JSON.stringify(GETMANUFACTURERSFORADDEQUIP))
      .subscribe((Response: any) => {
        this.EquipmentManufacturerDataSource = [];
        if (Response.manufacturers.length > 0) {
          //this.batchUtilizesDeviceRadioValue = 1;
          for (let c of Response.manufacturers) {
            this.EquipmentManufacturerDataSource.push({
              label: c.manufacturerName,
              value: c.manufacturerId
            });
          }
        }
      });
  }

  //Ger Model Parts
  getModelParts(ModelObj: any) {
    
    this.loading=true;
    this.ModelPartsDataSource = [];
    this.showParts=false;
    this.partsService.getModelParts(JSON.stringify(ModelObj))
      .subscribe((allModelPartsResponse: any) => { 
        this.loading=false;;       
        this.ModelPartsDataSource = [];        
        const map = new Map();
        if (allModelPartsResponse.parts.length > 0) {
          this.showParts=true;
          this.ModelPartsDataSource.push({
            label: "- Part -",
            value: -1
          });
          for (let c of allModelPartsResponse.parts) {
            if (!map.has(c.partDescription)) {
              map.set(c.partDescription, true);         
              this.ModelPartsDataSource.push({
                label: c.partDescription,
                value: c.partId
              });
            }
          }         
        }
      });
  }

  //Get Models For Add Equipment
  getModelsForAddEquip(GETMODELSFORADDEQUIP: any) {
     
    this.EquipmentModelDataSource = []; 
    
    this.modelService.getModelsForAddEquip(JSON.stringify(GETMODELSFORADDEQUIP))
      .subscribe((EquipmentModelResponse: any) => { 
        this.EquipmentModelDataSource = [];
       
        if (EquipmentModelResponse.models.length > 0) {
          for (let c of EquipmentModelResponse.models) {
            this.EquipmentModelDataSource.push({
              label: c.modelnumber,
              value: c.modelid
            });
          }
        }
      });
  }

  //Get SQA sub code
  getSqaSubCodes(GETSQASUBCODES: any) {
    this.SqaSubCodesDataSource = [];
    this.sqasubcodeService.getSqaSubCodes(JSON.stringify({
        GETSQASUBCODES
      }))
      .subscribe((allSqaSubCodesResponse: any) => {
        if (allSqaSubCodesResponse.length > 0) {
          this.SqaSubCodesDataSource = [];
          for (let c of allSqaSubCodesResponse) {
            this.SqaSubCodesDataSource.push({
              label: c.sqaSubDescription,
              value: c.sqaSubCodeId
            });
          }
        }

      }, (respose: Response) => {
        this.SqaSubCodesDataSource = [];
        // handle error here
      });
  }

  clickSetStatus(batchid: number,isActiveFlag: boolean) {
  
    var UPDATEBATCH = {
      "BatchId": batchid,
      "userId": this.userDetail.userId,
      "isActiveFlag":isActiveFlag==true?1:0
    }
    this.updateBatch(UPDATEBATCH); 
    this.SelectedRowData.isActiveFlag=0;   
  }

  updateBatch(UPDATEBATCH: any) {
    this.batchService.updateBatch(JSON.stringify({
        UPDATEBATCH
      }))
      .subscribe((updateBatchResponse: any) => {
        this.loadBatchData(this.batchObj);        

      }, (respose: Response) => {        
        // handle error here
      });
  }

  addBatch(ADDBATCH: any) {
    this.batchService.addBatch(JSON.stringify({
        ADDBATCH
      }))
      .subscribe((addBatchResponse: any) => {       
        this.SelectedRowData.batchid = addBatchResponse[0].BatchId;
        this.loadBatchData(this.batchObj);        
      }, (respose: Response) => {       
        // handle error here
      });
  }

  public onChangeEquipmentType() {  
    if(this.SelectedRowData.equipmenttypeid>=0)
    {  
      var GETEQUIPMENTSUBTYPES = {
        "equipmenttypeid": this.SelectedRowData.equipmenttypeid
      }
      this.getEquipmentSubtypes(GETEQUIPMENTSUBTYPES);
    }
  }

  public onChangeEquipmentSubType() {
    this.ObjGetManufacturersForAddeEuip = {
      "GETMANUFACTURERSFORADDEQUIP": {
        "equipmentTypeId": null,
        "equipmentSubTypeId":this.SelectedRowData.equipmentsubtypeid,
      }
    };
    this.getManufacturersForAddEquip(this.ObjGetManufacturersForAddeEuip);
    this.SelectedRowData.manufacturerId=null;
    this.SelectedRowData.ModelId=null;
  }

  //Get Model on change
  public onChangeEquipmentManufacturer() { 
    this.SelectedRowData.ModelId=null;   
    this.ObjGetObjGetManufacturersForAddeEuip = {
      "GETMODELSFORADDEQUIP": {
        "manufacturerId": this.SelectedRowData.manufacturerId,
        "equipmentTypeId": 0,
        "equipmentSubTypeId": 0
      }
    };
    this.getModelsForAddEquip(this.ObjGetObjGetManufacturersForAddeEuip);
  }

  loadYesNoFields() {
    this.measureYesNoList = [{
        label: '- Choose One -',
        value: -1
      },
      {
        label: 'Yes',
        value: 1
      },
      {
        label: 'No',
        value: 2
      }
    ];
  }

  public onChangeModel() {
    this.InformationShow = true;
    this.showEquipment = true;
    this.showManufacturer = true;
    //this.showDiscreteMeasures = true;
    this.showParts = false;
    this.showSummary = true;
    this.ObjGetModelParts = {
      "GETMODELPARTS": {
        "modelId": this.SelectedRowData.ModelId,
        "searchTerm": '',
        "sortColumn": 'partDescription ASC'
      }
    };
    this.getModelParts(this.ObjGetModelParts);
  }
  
  public onClickSaveEquipmentBtn() {
    {           
      var UPDATEBATCH = {
        "BatchId": this.SelectedRowData.batchid,
        "EquipmentTypeId": this.SelectedRowData.equipmenttypeid, 
        "EquipmentSubTypeId": this.SelectedRowData.equipmentsubtypeid,
        "userId": this.userDetail.userId,
      }

      // this.errors = [];
      // if (this.checkEquipmentTypeSubType() <= 0)
      // {
      //   return false;
      // }
      this.updateBatch(UPDATEBATCH);
      this.Header = "Batch Message";
      this.Content = "Batch updated successfully.";
      this.messagePopup = true;

      if (this.isEdite) {
        this.InformationShow = true;
        this.showEquipment = true;
        this.showManufacturer = true;
        this.showDiscreteMeasures = true;  
        this.showParts = true;
        this.showSummary = true;
      } else {
        this.InformationShow = true;
        this.showEquipment = true;
        this.showManufacturer = true;
        this.showDiscreteMeasures = false;

        this.showParts = false;
        this.showSummary = false;        
      }      
      this.index =2;     
    }
  }

  public onClickCompleteMeasureBtn() {
    this.index = 4; 
  }

  public onClickCompletePartBtn() {    
    this.index = 5;
    if (this.isEdite) {
      this.InformationShow = true;
      this.showEquipment = true;
      this.showManufacturer = true;
      this.showDiscreteMeasures = true;  
      this.showParts = true;
      this.showSummary = true;
    }
  }

  onClickSaveManufacturerBtn() {
    
    var UPDATEBATCH = {

      "BatchId": this.SelectedRowData.batchid,
      "ManufacturerId": this.SelectedRowData.manufacturerId,
      "ModelId": this.SelectedRowData["ModelId"],
      "userId": this.userDetail.userId,
    }

    this.errors = [];
    if (this.checkManufacturerForm() <= 0)
    {
      return false;
    }
    this.updateBatch(UPDATEBATCH);
    this.Header = "Batch Message";
    this.Content = "Batch updated successfully.";
    this.messagePopup = true;

    this.InformationShow = true;
    this.showEquipment = true;
    this.showManufacturer = true;
    //this.showDiscreteMeasures = true; 

    if(this.ModelPartsDataSource && this.ModelPartsDataSource.length>0)
    {
      this.showParts = true;
    }
    else
    {
      this.showParts = false;
    }
    this.showSummary = true;

    if(this.batchUtilizesDeviceRadioValue==1)
    {
      this.index = 3;   
    }
    else
    {
      if(this.isEdite && this.showParts && this.SelectedRowData.ModelId)
      {
        this.index = 5;
      }
      else
      {
        this.index = 4;
      }
      
    }
  }

  onClickSaveSummaryBtn() {
    {
      var UPDATEBATCH = {
        "BatchId": this.SelectedRowData.batchid,
        "ServiceRequested":this.SelectedRowData.servicerequested,
        "Findings": this.SelectedRowData.findings,
        "WorkPerformed":this.SelectedRowData.workperformed,
        "userId": this.userDetail.userId,
      }      
      this.updateBatch(UPDATEBATCH);
      this.Header = "Batch Message";
      this.Content = "Batch updated successfully.";
      this.messagePopup = true;
    }
  }
  
  //******************************** DISCRETE MEASURES *******************************//
  getBatchMeasures(batchId: number) {  
    {
      this.BatchMeasuresDataSource = [];
      if (batchId) {
        let batchtObj = {
          "GETBATCHMEASURES": {
            "Batchid": batchId
          }
        };
        this.loading = true;
        this.batchService.getBatchMeasures(JSON.stringify(batchtObj))
          .subscribe((batchMeasuresResponse: any) => {
            this.BatchMeasuresDataSource = [];
            this.SelectedRowData.countDiscreteMeasures = 0;
            if (batchMeasuresResponse.measures.length > 0) {
              this.BatchMeasuresDataSource = batchMeasuresResponse.measures;              
              this.BatchMeasuresDataSource=((this.uniqByKeepLast(this.BatchMeasuresDataSource, it =>it.discreteMeasureAttributeDesc)));               
              this.SelectedRowData.countDiscreteMeasures =  this.BatchMeasuresDataSource.length;
              if (this.isEdite) {
                if (this.SelectedRowData.countDiscreteMeasures == 0) {
                  this.showDiscreteMeasures = true;
                  this.showManufacturer = false;
                  this.showParts = false;
                }
              } else {
                this.showDiscreteMeasures = true;
                this.showManufacturer = true;
                this.showParts = true;
              }             
              this.loading = false;
            } else {
              this.BatchMeasuresDataSource = [];
              this.loading = false;

            }
            this.activateBatchUtilized();
            this.activateManufacturer();
          }, (respose: Response) => {
            this.BatchMeasuresDataSource = [];
            this.loading = false;
            // handle error here
          });
      }
    }
  }
  uniqByKeepLast(data, key)
  {
    return [
    ...new Map(
    data.map(x => [key(x), x])
    ).values()
    ]  
  }
  addDiscreteMeasure(batchObj: Object) {
    this.loading = true;
    this.batchService.addDiscreteMeasure(JSON.stringify(
        batchObj
      ))
      .subscribe((addDiscreteMeasureResponse: any) => {
        this.getBatchMeasures(this.SelectedRowData.batchid);
      }, (respose: Response) => {
        this.loading = false;
        // handle error here
      });
  }

  //Update Measures
  updateDiscreteMeasure(batchObj: Object) {
    this.loading = true;
    this.batchService.updateDiscreteMeasure(JSON.stringify(
        batchObj
      ))
      .subscribe((updateDiscreteMeasureResponse: any) => {
        this.getBatchMeasures(this.SelectedRowData.batchid);
      }, (respose: Response) => {
        this.loading = false;
        // handle error here
      });
  }
  //Delete Discrete Measure
  deleteDiscreteMeasure(DELETEDISCRETEMEASURE: any) {
    this.loading = true;
    this.batchService.deleteDiscreteMeasure(JSON.stringify({
        DELETEDISCRETEMEASURE
      }))
      .subscribe((deleteDiscreteMeasureResponse: any) => {
        this.getBatchMeasures(this.SelectedRowData.batchid);

      }, (respose: Response) => {
        this.getBatchMeasures(this.SelectedRowData.batchid);
        // handle error here
      });
  }

  //Delete Batch
  deleteBatch(DELETEBATCH: any) {

    this.batchService.deleteBatch(JSON.stringify({
        DELETEBATCH
      }))
      .subscribe((deleteBatchResponse: any) => {
        this.loadBatchData(this.batchObj);
      }, (respose: Response) => {
        this.loadBatchData(this.batchObj);
        // handle error here
      });
  }

  //Select Measure for update
  clickUpdateBatchMeasure(discreteMeasureId: number) { 
    let RowData: any = this.BatchMeasuresDataSource.find(x => x.discreteMeasureId == discreteMeasureId);
    this.SelectedBatchMeasureRowData = Object.assign({}, RowData);

    this.SelectedBatchMeasureRowData.discreteMeasureId = this.SelectedBatchMeasureRowData["discreteMeasureId"];
    this.SelectedBatchMeasureRowData.discreteMeasureAttributeId = this.SelectedBatchMeasureRowData["discreteMeasureAttributeId"];
    this.SelectedBatchMeasureRowData.discreteMeasureTypeId = this.SelectedBatchMeasureRowData["discreteMeasureTypeId"];

    this.SelectedBatchMeasureRowData.MinValue = this.SelectedBatchMeasureRowData["minValue"];
    this.SelectedBatchMeasureRowData.MaxValue = this.SelectedBatchMeasureRowData["maxValue"];

    this.SelectedBatchMeasureRowData.minDate1 = this.datePiepe.transform(this.SelectedBatchMeasureRowData["minDate"], "MM/dd/yyyy");
    this.SelectedBatchMeasureRowData.maxDate1 = this.datePiepe.transform(this.SelectedBatchMeasureRowData["maxDate"], "MM/dd/yyyy");
   
    this.SelectedBatchMeasureRowData.answer = this.SelectedBatchMeasureRowData["answer"];    
    this.SelectedBatchMeasureRowData.discreteMeasureTypeDesc = this.SelectedBatchMeasureRowData["discreteMeasureTypeDesc"];
    this.SelectedBatchMeasureRowData.discreteMeasureAttributeDesc = this.SelectedBatchMeasureRowData["discreteMeasureAttributeDesc"];

    this.isDisabled = true;
    this.showHideaddMeasureBtn = true;
    this.showHidesaveMeasureBtn = false;
    this.showHidecancelMeasureBtn = false;
    

  }

  //Update Measure on click
  onClickSaveMeasureBtn() {
    
    let objMeasure = {
      "UPDATEDISCRETEMEASURE": {
        "discreteMeasureId": this.SelectedBatchMeasureRowData.discreteMeasureId,
        "BatchId": this.SelectedRowData.batchid,
        "discreteMeasureAttributeId": this.SelectedBatchMeasureRowData.discreteMeasureAttributeId,
        "minValue": this.SelectedBatchMeasureRowData.MinValue,
        "maxValue": this.SelectedBatchMeasureRowData.MaxValue,
        "minDate": this.SelectedBatchMeasureRowData.minDate1,
        "maxDate": this.SelectedBatchMeasureRowData.maxDate1,
        "answer": this.SelectedBatchMeasureRowData.answer
      }
    };

    this.errors = [];
    if (this.checkMeasureForm() <= 0) //Validation
    {
      return false;
    }
    this.updateDiscreteMeasure(objMeasure);
    this.resetDiscreteMeasure();
    this.showHideaddMeasureBtn = false;
    this.showHidesaveMeasureBtn = true;
    this.showHidecancelMeasureBtn = true;  

  }

  //Add Measures  

  onAddMeasureBtn() {
      
    var objMeasure = {
      "ADDDISCRETEMEASURE": {
        "BatchId": this.SelectedRowData.batchid,
        "discreteMeasureAttributeId": this.SelectedBatchMeasureRowData.discreteMeasureAttributeId,
        "minValue": this.SelectedBatchMeasureRowData.MinValue,
        "maxValue": this.SelectedBatchMeasureRowData.MaxValue,
        "minDate": this.SelectedBatchMeasureRowData.minDate1,
        "maxDate": this.SelectedBatchMeasureRowData.maxDate1,
        "answer": this.SelectedBatchMeasureRowData.answer
      }
    };

    this.errors = [];
    if (this.checkMeasureForm() <= 0)
    {
      return false;
    }

    this.addDiscreteMeasure(objMeasure);
    this.resetDiscreteMeasure();    
  }

  resetDiscreteMeasure() {
    this.SelectedBatchMeasureRowData.discreteMeasureAttributeId = null;
    this.SelectedBatchMeasureRowData.MinValue = null;
    this.SelectedBatchMeasureRowData.MaxValue = null;
    this.SelectedBatchMeasureRowData.minDate1 = null;
    this.SelectedBatchMeasureRowData.maxDate1 = null;
    this.SelectedBatchMeasureRowData.answer = null;  
    this.isDisabled = false;
  }
  clickRemoveBatchMeasure(discreteMeasureId: number) {
    this.bmConfirmation=true;
    this._confirmationService.confirm({
      message: 'Are you sure you want to remove the selected row?',
      accept: () => {  
        var DELETEDISCRETEMEASURE = {
        BatchId: this.SelectedRowData.batchid,
        discreteMeasureId: discreteMeasureId
      }
      this.deleteDiscreteMeasure(DELETEDISCRETEMEASURE);
      this.getBatchMeasures(this.SelectedRowData.batchid);
      },
      reject: () => {              
        this.bmConfirmation=false;
      }

    });

    this.showHideaddMeasureBtn = false;
    this.showHidesaveMeasureBtn = true;
    this.showHidecancelMeasureBtn = true;
  }

  //Cancel Measure
  onClickCancelMeasureBtn() {    
    this.highLightRow(0);
    this.SelectedBatchMeasureRowData.discreteMeasureAttributeId=null;
    this.SelectedBatchMeasureRowData.minDate1 = null;
    this.SelectedBatchMeasureRowData.maxDate1 = null;
    this.SelectedBatchMeasureRowData.MinValue = null;
    this.SelectedBatchMeasureRowData.MaxValue = null;
    this.SelectedBatchMeasureRowData.answer = null; 
    this.isDisabled = false;
    this.showHideaddMeasureBtn = false;
    this.showHidesaveMeasureBtn = true;
    this.showHidecancelMeasureBtn = true;
  }

  clickcloseEntryBtn() {

    this.InformationShow = true;
    this.showEquipment = false;
    this.showManufacturer = false; 
    this.showDiscreteMeasures = false;  
    this.showParts = false;
    this.showSummary = false;

    this.divBatchEntryShow = false;
    this.divBatchInfoBoxShow = false;
    this.divBatchListings = true;
    this.tableBatchName = null;
    this.SelectedBatchMeasureRowData.discreteMeasureAttributeId=null;
  }

  onClickAddPartBtn() {    
    let objBatchPart = {
      "ADDBATCHPART": {
        "BatchId": this.SelectedRowData.batchid,
        "partId": this.SelectedBatchPartRowData.SelectedPartId,
        "quantity": this.SelectedBatchPartRowData.PartQuantity,
        "userId": this.userDetail.userId,
      }
    };

    this.errors = [];
    if (this.checkPartForm() <= 0)
    {
      return false;
    }
   
    this.addBatchPart(objBatchPart);
    // this.getBatchParts(this.SelectedRowData.batchid);
    this.SelectedBatchPartRowData.PartQuantity = null;    
    this.SelectedBatchPartRowData.SelectedPartId=null;
    
    this.showHideaddPartBtn = false;
    this.showHidesavePartBtn = true;
    this.showHidecancelPartBtn = true; 
  }

  addBatchPart(partObj: Object) {
    this.loading=true;
    this.batchService.addBatchPart(JSON.stringify(partObj))
      .subscribe((addBatchPartResponse: any) => {
        this.getBatchParts(this.SelectedRowData.batchid);
      },
        (respose: Response) => {
          this.loading=false;
          // handle error here
        });
  }

  public getBatchParts(batchId) {  
       
    let partObj = {
      "GETBATCHPARTS": {
        BatchId: batchId,
        PartId: null
      }
    }
    this.loading = true;    
    this.batchService.getBatchParts(JSON.stringify(partObj))
      .subscribe((getBatchPartResponse: any) => {         
          this.SelectedRowData.countBatchPart = 0;
          if (getBatchPartResponse.parts.length > 0) {
            this.SelectedRowData.countBatchPart = getBatchPartResponse.parts.length;
            this.batchPartDataSource = getBatchPartResponse.parts;           
            this.changeDetectorRef.detectChanges();
            this.loading = false;
          } else {           
            this.batchPartDataSource = [];
            this.loading = false;
          } 
          this.activateBatchUtilized();
          this.activateManufacturer();                 
        },
        (error) => {
          console.log(error)
        }
      )
  }

  public clickUpdateBatchPart(batchPartId) { 
    let RowData: any = this.batchPartDataSource.find(x => x.batchPartId == batchPartId);
    this.SelectedBatchPartRowData = RowData;    
    this.SelectedBatchPartRowData.SelectedPartId = this.SelectedBatchPartRowData["partId"];
    this.SelectedBatchPartRowData.PartQuantity = this.SelectedBatchPartRowData["quantity"];

    this.ObjGetModelParts = {
      "GETMODELPARTS": {
        "modelId": this.SelectedRowData.ModelId,
        "searchTerm": '',
        "sortColumn": 'partDescription ASC'
      }
    }
    //this.getModelParts(this.ObjGetModelParts);
    this.showHideaddPartBtn = true;
    this.showHidesavePartBtn = false;
    this.showHidecancelPartBtn = false;
    this.isDisabled = false;
  }

  //Update batch part
  onClickSavePartBtn() {  
    
    let objBatchPart = {
      "UPDATEBATCHPART": {
        "BatchPartId": this.SelectedBatchPartRowData.batchPartId,
        "quantity": this.SelectedBatchPartRowData.PartQuantity, //this.SelectedBatchPartRowData.quantity,
        "userId": this.userDetail.userId
      }
    };
    this.errors = [];
    if (this.checkPartForm() <= 0)
    {
      return false;
    }
    this.updaBatchPart(objBatchPart);
    //this.getBatchParts(this.SelectedRowData.batchid);
    this.showHideaddPartBtn = true;
    this.showHidesavePartBtn = false;
    this.showHidecancelPartBtn = false;   
    this.SelectedBatchPartRowData.PartQuantity=null;
    this.SelectedBatchPartRowData.SelectedPartId=null;
  }

  updaBatchPart(partObj: Object) {
    this.loading=true;
    this.batchService.updateBatchPart(JSON.stringify(partObj))
      .subscribe((addBatchPartResponse: any) => {
        this.getBatchParts(this.SelectedRowData.batchid)
      },
        (respose: Response) => {
          this.loading=true;
          // handle error here
        });
  }

  // Remove Batch Part
  public clickRemoveBatchPart(batchId, batchPartId) {    
    var DELETEBATCHPART = {
      "BatchId": batchId,
      "batchPartId": batchPartId
    } 
    
    this.bmConfirmation=true;
    this._confirmationService.confirm({
      message: 'Are you sure you want to remove the selected row?',
      accept: () => {              
        this.deleteBatchPart(DELETEBATCHPART);
        //this.getBatchParts(this.SelectedRowData.batchid);
        this.Header = "Part Message";
        this.Content = "Part deleted";
        this.messagePopup = true;
      },
      reject: () => {              
        this.bmConfirmation=false;
      }

    });
   
    this.getBatchParts(batchId);

    this.showHideaddPartBtn = false;
    this.showHidesavePartBtn = true;
    this.showHidecancelPartBtn = true;
    this.isDisabled = false;
    this.SelectedBatchPartRowData.PartQuantity=null;
    this.SelectedBatchPartRowData.SelectedPartId=null;
  }

  //Cancel Part
  onClickCancelPartBtn() {
    this.showHideaddPartBtn = false;
    this.showHidesavePartBtn = true;
    this.showHidecancelPartBtn = true;
    this.isDisabled = false;
    this.SelectedBatchPartRowData.SelectedPartId = null;
    this.SelectedBatchPartRowData.PartQuantity = null;
  }

  closeClick(eventId: string) {
    this.messagePopup = false;
    this.ErroDialog = false;
  }

  public clickbatchUtilizesDevicesYes() {
    this.showDiscreteMeasures = true;
    //this.showManufacturerItem = true;
    //this.batchUtilizesDeviceRadioValue = 1;


  }
  public clickbatchUtilizesDevicesNo() {
    //this.batchUtilizesDeviceRadioValue = 0;    
    //this.InformationShow = true;
    //this.showEquipment = true;
    //this.showManufacturer = true;
    this.showDiscreteMeasures = true; 
    // this.showParts = true;
    this.showSummary = true;
    this.SelectedRowData.manufacturerId=null;
    this.SelectedRowData.ModelId=null;

  }


  
  disBatchUtilized: boolean= false;
  public activateBatchUtilized() { 
     
    this.disBatchUtilized = true;
    if ((this.SelectedRowData.countBatchPart == 0) && (this.SelectedRowData.countDiscreteMeasures == 0)) {
      this.disBatchUtilized = false;
    }
  }

  disManufacturer: boolean= false;
  public activateManufacturer() {
      
    this.disManufacturer = true;
    if (this.SelectedRowData.countBatchPart == 0) {
      this.disManufacturer = false;
    }
  }

onTabChange(e){
  this.index=e.index;
}


  //Batch Validation
  checkErrors() {
    this.errors = [];
    if (this.SelectedRowData.BatchName == "") {
      this.errors.push("Name is required.");
    }
    if (this.SelectedRowData.batchdescription == "") {
      this.errors.push("Description is required.");
      } else {
        if (this.SelectedRowData.batchdescription.length > 250) {
          this.errors.push("Description is too long.");
        }
    }
    //check if valid date
    var isEffectiveDateValid = null;
    var isExpirationDateValid = null;

    if (this.SelectedRowData.effectiveDate != "") {
      isEffectiveDateValid = this.datePiepe.transform(this.SelectedRowData.effectiveDate, "mm/dd/yy");
    }
    if (this.SelectedRowData.expirationDate != "") {
      isExpirationDateValid = this.datePiepe.transform(this.SelectedRowData.expirationDate, "mm/dd/yy");
    }    
    if (isEffectiveDateValid != null && isExpirationDateValid != null) {
      var currDate = new Date();
      var effDate = new Date(this.SelectedRowData.effectiveDate);
      var expDate = new Date(this.SelectedRowData.expirationDate);

      if (effDate > expDate) {
        this.errors[this.errors.length] = "Effective date cannot be after expiration date.";
      }
      if (expDate < currDate) {
        this.errors[this.errors.length] = "Expiration date cannot be before today's date.";
      }
    }
    if (this.SelectedRowData.payrollcodeid == null) {
      this.errors.push("Payroll code is required.");
    }
    if (this.SelectedRowData.worktypeid == null || this.SelectedRowData.worktypeid<=0) {
      this.errors.push("Work type is required.");
    }
    if (this.SelectedRowData.sqacodeid == null) {
      this.errors.push("SQA Code is required.");
    } else {
      if (this.SelectedRowData.sqasubcodeid == null && this.SelectedRowData.sqacodeid == 14) {
        this.errors.push("SQA Sub Code is required.");
      }
    }
    if (this.errors.length) {
      this.ErroDialog = true;
      return 0;
    }
    return 1;
  }

  checkMeasureForm() {
    if (this.SelectedBatchMeasureRowData.discreteMeasureAttributeId == -1 || this.SelectedBatchMeasureRowData.discreteMeasureAttributeId == undefined || this.SelectedBatchMeasureRowData.discreteMeasureAttributeId == null) {
      this.errors.push("Please select an attribute.");
    }
    var meas = this.SelectedBatchMeasureRowData.discreteMeasureAttributeId;
    if (meas == 4) {
      var sDate = this.SelectedBatchMeasureRowData.minDate1;
      var eDate = this.SelectedBatchMeasureRowData.maxDate1;
      var isStartDateValid = this.datePiepe.transform(sDate, "MM/dd/yyyy");
      var isEndDateValid = this.datePiepe.transform(sDate, "MM/dd/yyyy");
      var checkDate = true;

      if (isStartDateValid == null || sDate == "") {
        this.errors.push("Please enter a valid to date.");
        checkDate = false;
      }
      if (isEndDateValid == null || eDate == "") {
        this.errors.push("Please enter a valid from date.");
        checkDate = false;
      }
      if (checkDate) {
        sDate = new Date(sDate);
        eDate = new Date(eDate);
        if (sDate > eDate) {
          this.errors[this.errors.length] = "To date cannot be after From date.";
        }
      }
    }    
    if ((meas == 1) || (meas == 2) || (meas == 3) || (meas == 7) || (meas == 8) || (meas == 9) || (meas == 10) || (meas == 11) || (meas == 12) || (meas == 13) || (meas == 14)) {
      var minMeas = this.SelectedBatchMeasureRowData.MinValue;
      var maxMeas = this.SelectedBatchMeasureRowData.MaxValue;
      var checkNum = true;

      if (isNaN(minMeas) || minMeas == "" || minMeas == null) {
        this.errors.push("Please enter a valid minimum value.");
        checkNum = false;
      }
      if (isNaN(maxMeas) || maxMeas == "" || maxMeas == null) {
        this.errors.push("Please enter a valid maximum value.");
        checkNum = false;
      }
      if (checkNum) {
        if (parseFloat(minMeas) > parseFloat(maxMeas)) {
          this.errors.push("The minimum value is greater than the maximum value.");
        }
      }
    }
    if ((meas == 5) || (meas == 6)) {
      var ans = this.SelectedBatchMeasureRowData.answer;
      if ((ans == null) || (ans <0 )) {
        this.errors.push("Please select yes or no.");
      }
    }

    if (this.errors.length) {
      this.ErroDialog = true;
      return 0;
    }
    return 1;
  }
  //Part Validation
  checkPartForm() {
    this.errors = [];    
    if (this.SelectedBatchPartRowData.SelectedPartId== -1 || this.SelectedBatchPartRowData.SelectedPartId == null) {
      this.errors.push("Please select part name.");
    }
    if (this.SelectedBatchPartRowData.PartQuantity == null) {
      this.errors.push("Part quantity is required.");
    }
    if (isNaN(this.SelectedBatchPartRowData.PartQuantity)) {
      this.errors.push("Please enter a valid quanitity.");
    }
    if (this.errors.length) {
      this.ErroDialog = true;
      return 0;
    }
    return 1;
  }

  //Manufacturer Validation
  checkManufacturerForm() {
    this.errors = [];

    var manuId = this.SelectedRowData.manufacturerId;
    var isUtilized = this.batchUtilizesDeviceRadioValue;
    if (isUtilized == 1) {
      if (manuId == null || manuId == undefined) {
        this.errors.push("Manufacturer is required.")
      }
    }
    if (this.errors.length) {
      this.ErroDialog = true;
      return 0;
    }
    return 1;
  }
//Validation removed after discussion with business on 22/10/2020
  //Equipment Type and sub type validation Validation
  // checkEquipmentTypeSubType() {
  //   this.errors = [];
  //   if (this.SelectedRowData.equipmenttypeid == null || this.SelectedRowData.equipmenttypeid == -1) {
  //     this.errors.push("Equipment Type is required.");
  //   }
  //   if (this.SelectedRowData.equipmentsubtypeid == null || this.SelectedRowData.equipmentsubtypeid == -1) {
  //     this.errors.push("Equipment Sub Type is required.");
  //   }
  //   if (this.errors.length) {
  //     this.ErroDialog = true;
  //     return 0;
  //   }
  //   return 1;
  // }
  public showSaveSummaryBtn: boolean=false;

  checkSummaryValues() {    
    this.showSaveSummaryBtn=false;    
    var summaryChars = 0;
    if(this.SelectedRowData.servicerequested!=null) {
      var charLen = this.SelectedRowData.servicerequested.length;     
      if (charLen > 0) {
        summaryChars += charLen;
      }
    }    
    if (summaryChars > 0) {     
      this.showSaveSummaryBtn=true;
    }
  }

  public onChangegetSqaSubCodes()
  {
    this.getSqaSubCodes(this.GETSQASUBCODES);
  }
}
